import { inject } from 'inversify';
import { TrackingPlugin, StartError, Result, ok, err,
         TrackingDetails, PluginDetails, startError
       } from '../../../tracking-api';
import { StoreCommandExecutor, Command, Query } from '../../../common';
import { HandledEvents } from './handled-events';
import * as Client from '../client';
import { TinCanEventHandler } from './tincan-event-handler';

export class TinCanTrackingPlugin implements TrackingPlugin<HandledEvents> {
  private initialized: boolean;

  constructor(public readonly details: PluginDetails,
              private readonly parameterResolver: Client.TinCanLaunchParametersResolver,
              private readonly xApiClient: Client.XApiClient,
              private readonly eventHandler: TinCanEventHandler,
              @inject(StoreCommandExecutor)
              private readonly commandExecutor: StoreCommandExecutor) {

  }

  public async start(details: TrackingDetails): Promise<Result<true, StartError>> {

    const parameterResult = this.parameterResolver.resolve();
    if (!parameterResult.success) {
      return startError('invalid-parameters', parameterResult.error);
    }
    const initializeResult = this.xApiClient.initialize(parameterResult.value);
    if (!initializeResult.success) {
      return startError('invalid-parameters', initializeResult.error);
    }

    await this.commandExecutor.start();

    this.initialized = true;

    return ok(true);
  }

  public async finish(): Promise<Result<true, 'not-started'>> {

    if (!this.initialized) {
      return err('not-started');
    }

    await this.commandExecutor.finish();
    await this.xApiClient.finish();

    return ok(true);
  }

  public async handleEvent(event: any): Promise<void> {
    await this.eventHandler.handleEvent(event);
  }

  public execute(command: Command) {
    throw new Error('Not implemented')
  }

  public query<T extends string, TPayload, TResult>(query: Query<T, TPayload, TResult>): Promise<TResult> {
    throw new Error('Not implemented')
  }
}


